/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ErrorReason,
    ErrorReasonFromJSON,
    ErrorReasonFromJSONTyped,
    ErrorReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface UploadFileInfo
 */
export interface UploadFileInfo {
    /**
     * 
     * @type {string}
     * @memberof UploadFileInfo
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadFileInfo
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadFileInfo
     */
    hash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadFileInfo
     */
    caseFileId?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileInfo
     */
    processingResultText?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadFileInfo
     */
    processingSuccess?: boolean | null;
    /**
     * 
     * @type {ErrorReason}
     * @memberof UploadFileInfo
     */
    errorReason?: ErrorReason;
}

export function UploadFileInfoFromJSON(json: any): UploadFileInfo {
    return UploadFileInfoFromJSONTyped(json, false);
}

export function UploadFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
        'caseFileId': !exists(json, 'caseFileId') ? undefined : json['caseFileId'],
        'processingResultText': !exists(json, 'processingResultText') ? undefined : json['processingResultText'],
        'processingSuccess': !exists(json, 'processingSuccess') ? undefined : json['processingSuccess'],
        'errorReason': !exists(json, 'errorReason') ? undefined : ErrorReasonFromJSON(json['errorReason']),
    };
}

export function UploadFileInfoToJSON(value?: UploadFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'key': value.key,
        'hash': value.hash,
        'caseFileId': value.caseFileId,
        'processingResultText': value.processingResultText,
        'processingSuccess': value.processingSuccess,
        'errorReason': ErrorReasonToJSON(value.errorReason),
    };
}


